import throttle from 'lodash/throttle'
import Scrollbar from 'smooth-scrollbar'

import Emitter from '../../core/Emitter'
import {
  disableScrolling as disableScrollingNative,
  enableScrolling as enableScrollingNative,
  getScroll as getScrollNative,
  getScrollTop as getScrollTopNative,
} from '../Viewport/scroll'
import scrollToElementNative from '../Viewport/scrollToElement'

class Scroll extends Emitter {

    constructor(context = window) {
        super()

        this.context = context
        this.current = {
            x: 0,
            y: 0
        }
        this.raf = null
        this.container = document.querySelector('.scroll-Container')

        this.handleResize = throttle(this.handleResize, 100)

        window.addEventListener('resize', this.handleResize)
        window.addEventListener('scroll', this.handleNativeScroll)

        this.scrollbar = null
        this.isVirtual = false

        this.staticLimit = {
            x: this.container.offsetWidth - window.innerWidth,
            y: this.container.offsetHeight - window.innerHeight
        }
    }

    getScroll() {
        if (this.isVirtual) {
            return {
                x: this.scrollbar.scrollLeft,
                y: this.scrollbar.scrollTop,
                limit: this.scrollbar.limit
            }
        } else {
            return getScrollNative()
        }
    }

    handleNativeScroll = () => {
        if (this.isVirtual) {
            return
        }

        this.current = getScrollNative()

        this.render()
    }

    handleResize = () => {
        this.resize()
    }

    handleVirtualScroll = status => {
        this.current = {
            x: status.offset.x,
            y: status.offset.y
        }

        this.render()
    }

    render = () => {
        this.emit('scroll', {
            offset: {...this.current}
        })
    }

    resize = () => {
        if (!this.isVirtual) {
            this.staticLimit = {
                x: this.container.offsetWidth - window.innerWidth,
                y: this.container.offsetHeight - window.innerHeight
            }
        }
        this.emit('resize')
    }

    setPosition(x, y) {
        if (this.isVirtual) {
            this.scrollbar.setPosition(x, y)
        } else {
            document.documentElement.scrollLeft = x
            document.documentElement.scrollTop = y
        }
    }

    useNative() {
        if (!this.isVirtual) {
            return
        }

        this.isVirtual = false
        this.container.classList.remove('is-virtual')
    }

    useVirtual() {
        if (this.isVirtual) {
            return
        }

        this.isVirtual = true
        this.container.classList.add('is-virtual')

        if (!this.scrollbar) {
            this.scrollbar = Scrollbar.init(this.container, {
                renderByPixels: false
            })
            this.scrollbar.addListener(this.handleVirtualScroll)
        }
    }

    getLimit() {
        if (this.isVirtual && this.scrollbar) {
            return this.scrollbar.limit
        } else {
            return this.staticLimit
        }
    }

}

const scrollInstance = new Scroll()

export function scrollToElement(element, options = { offset: 80 }) {
    if (scrollInstance.isVirtual) {
        scrollInstance.scrollbar.scrollIntoView(element, {
            offsetTop: options.offset ? options.offset : 0,
            onlyScrollIfNeeded: options.loose,
            alignToTop: true
        })
    } else {
        scrollToElementNative(element, options)
    }
}

export function getScroll() {
    if (scrollInstance.isVirtual) {
        return scrollInstance.scrollbar.offset
    } else {
        return getScrollNative()
    }
}

export function getScrollTop() {
    if (scrollInstance.isVirtual) {
        return scrollInstance.scrollbar.scrollTop
    } else {
        return getScrollTopNative()
    }
}

export function disableScrolling() {
    disableScrollingNative()
}

export function enableScrolling() {
    enableScrollingNative()
}

window.scrollInstance = scrollInstance

export default scrollInstance
